var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title-image-container",class:_vm.device.isMobile ? 'title-image-container-mobile' : '',style:({
    fontFamily: _vm.content.textStyle.fontFamily || '',
    fontSize: (_vm.content.textStyle.fontSize + 'rem') || '',
    lineHeight: (_vm.content.textStyle.lineHeight + 'rem') || '',
    textIndent: (typeof _vm.content.textStyle.textIndent === 'string') ? _vm.content.textStyle.textIndent :
      (typeof _vm.content.textStyle.textIndent === 'number') ? (_vm.content.textStyle.textIndent + 'rem') : '',
    fontWeight: _vm.content.textStyle.fontWeight || '',
    textDecoration: _vm.content.textStyle.underline === 1 ? 'underline' : '',
    fontStyle: _vm.content.textStyle.fontItalic === 1 ? 'italic' : '',
    textAlign: _vm.content.textStyle.textAlign || '',
    color: _vm.content.textStyle.color || '',
    backgroundColor: _vm.content.textStyle.backgroundColor || '',
    backgroundImage: _vm.content.textStyle.backgroundImage ? ("url(" + (_vm.content.textStyle.backgroundImage) + ")") : '',
    marginTop: (_vm.content.textStyle.marginTop + 'rem') || '',
    marginBottom: (_vm.content.textStyle.marginBottom + 'rem') || '',
  }),attrs:{"id":_vm.content.key}},[_c('img',{staticClass:"img",style:({
      width: (_vm.content.titleImageWidth + 'rem') || '',
      margin: _vm.content.titleImagePosition === 'left' ? 0 : '',
    }),attrs:{"id":((_vm.content.key) + "-1"),"src":_vm.content.titleImage || require('@/assets/images/books/book1/title-back.png'),"alt":""}}),_c('span',{staticClass:"text",attrs:{"id":((_vm.content.key) + "-2")},domProps:{"innerHTML":_vm._s(_vm.content.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }